import { connect } from 'react-redux';
import { GET_PLACE_DETAIL, RESET_PLACE_DETAILS } from 'store/place/actionTypes';
import Contract from './Contract';

const mapStateToProps = (state) => ({
  isLoadingGetPlaceDetail: state.Place.isLoadingGetPlaceDetail,
  placeDetail: state.Place.placeDetail,
});

const mapDispatchToProps = (dispatch) => ({
  actionGetPlaceDetail: (payload) => dispatch({
    type: GET_PLACE_DETAIL,
    payload,
  }),
  actionResetPlaceDetail: () => dispatch({
    type: RESET_PLACE_DETAILS,
  }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Contract);
